/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import { i18n } from "@/plugins/i18n";
import App from "./App.vue";

//VueLogger
import vueLogger from "vuejs-logger";

const isProduction = process.env.NODE_ENV === "production";

const options = {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true,
};

Vue.use(vueLogger, options);

// SetInterval
import SetInterval from "@/plugins/setInterval";

Vue.use(SetInterval);

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";

Vue.use(VueHammer);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

// VeeValidate (日本語)
import VeeValidate, { Validator } from "vee-validate";
import ja from "vee-validate/dist/locale/ja";

Validator.localize("ja", ja);
Vue.use(VeeValidate, { locale: ja });

// Vue select css
// Note: In latest version you have to add it separately
import "vue-select/dist/vue-select.css";

Vue.config.productionTip = false;

// VueLazyLoad
import VueLazyLoad from "vue-lazyload";

Vue.use(VueLazyLoad);

// VueShortKey
Vue.use(require("vue-shortkey"));

// VueCtkDateTimePicker
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

Vue.component("vue-ctk-date-time-picker", VueCtkDateTimePicker);

// lightbox CSS
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");

import "vue-awesome/icons";
import Icon from "vue-awesome/components/Icon";

// IdleVue
import IdleVue from "idle-vue";
const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 60000 * 30, // 30 minutes
  startAtIdle: false,
});
Vue.component("awe-icon", Icon);

// v-calendar"
import VCalendar from "v-calendar";
Vue.use(VCalendar);

// vue-nprogress"
import NProgress from "vue-nprogress";
const NProgressOptions = {
  latencyThreshold: 100,
  router: false,
  http: false,
};
Vue.use(NProgress, NProgressOptions);

const nprogress = new NProgress();
nprogress.configure({ showSpinner: false, easing: "ease", speed: 600 });

// PortalVue
import PortalVue from "portal-vue";
Vue.use(PortalVue);

new Vue({
  router,
  store,
  i18n,
  vueLogger,
  nprogress,
  render: h => h(App),
}).$mount("#app");
